"use client";

import { ReactNode, useLayoutEffect, useRef, useState } from "react";
import styles from "./AutoHeight.module.css";

type Props = {
  children: ReactNode;
};

export default function AutoHeight(props: Props) {
  const { children } = props;

  const innerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | null>(null);

  useLayoutEffect(() => {
    const node = innerRef.current;
    if (!node) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      setHeight(entries[0].contentRect.height);
    });
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.container} style={height === null ? undefined : { height }}>
      <div ref={innerRef}>{children}</div>
    </div>
  );
}
